import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AttendanceTimelineSessionComponent } from '../attendance-timeline-session/attendance-timeline-session.component';
import { AttendanceTimelineAnomalyComponent } from '../attendance-timeline-anomaly/attendance-timeline-anomaly.component';
import { AttendanceTimelineEventComponent } from '../attendance-timeline-event/attendance-timeline-event.component';
import { Session } from 'src/app/queries/generated';

@Component({
  selector: 'lv-attendance-timeline',
  templateUrl: 'attendance-timeline.component.html',
  styleUrls: ['attendance-timeline.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    AttendanceTimelineSessionComponent,
    AttendanceTimelineAnomalyComponent,
    AttendanceTimelineEventComponent,
    DatePipe
  ]
})
export class AttendanceTimelineComponent {
  @Input() sessions: Session[];
}
